import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const FeesNavUI = ({context, page}) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='Fee Tracker1' to='/su/fees' active={page==='fees'} />
      <TabLinkUI label='Fee Tracker2' to='/su/fees/feeTracker2' active={page==='feeTracker2'} />
    </div>
    <div className='g_m_top_50' />
  </div>

export default FeesNavUI